var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-content bg-white text-gray-700 text-center py-8"},[_c('div',{staticClass:"text-lg max-w-2xl mx-auto",domProps:{"innerHTML":_vm._s(_vm.sectionContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }